export const getLabel = (cohortAge: string): string => {
  return `Day ${cohortAge.slice(1)}`;
};
